import { FC } from "react";
import { Checkbox, CheckboxRootProps, Text } from "@chakra-ui/react";

import { FONT_WEIGHT } from "@assets/theme/foundations/textStyle";

interface RemoveCaseDocumentOptionProps extends Omit<CheckboxRootProps, "onChange"> {
  title: string;
  note?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

const RemoveCaseDocumentOption: FC<RemoveCaseDocumentOptionProps> = ({
  title,
  note,
  checked,
  disabled,
  onChange,
  ...props
}) => (
  <Checkbox.Root
    checked={checked}
    disabled={disabled}
    onCheckedChange={(details) => onChange(details.checked === true)}
    alignItems="flex-start"
    gap={3}
    px={4}
    py="14px"
    borderRadius="8px"
    bg="brand.bg"
    cursor="pointer"
    {...props}
  >
    <Checkbox.HiddenInput />
    <Checkbox.Control mt="2px" _checked={{ bg: "brand.primary", borderColor: "brand.primary" }} />
    <Checkbox.Label display="flex" flexDirection="column" gap="3px">
      <Text fontSize="14px" fontWeight={FONT_WEIGHT.HEAVY} color="brand.modalHeaderText">
        {title}
      </Text>
      {note && (
        <Text fontSize="13px" fontWeight="normal" lineHeight={1.5} color="brand.textSecondary">
          {note}
        </Text>
      )}
    </Checkbox.Label>
  </Checkbox.Root>
);

export default RemoveCaseDocumentOption;
